import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles((() => {

  const background = (
    theme.portal
    && theme.portal.header
    && theme.portal.header.background
  ) || '#333';

  const logo = (
    theme.portal
    && theme.portal.logo
  ) || '';

  const minimisedlogo = (
    theme.portal
    && theme.portal.minimisedlogo
  ) || logo || '';

  const logoBgSize = (
    theme.portal
    && theme.portal.logoBGSize
  ) || '';

  return {
    contactDetails: {
      color: theme.palette.getContrastText(background),
    },
    headerLogoLink: {
      display: "block",
      overflow: 'hidden',
      width: '100%',
      '& > a': {
        width: '100%',
        textIndent: '-99999px',
        display: 'block',
        height: 43,
        maxWidth: 150,
        backgroundSize: logoBgSize,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${logo})`,
        [theme.breakpoints.down('sm')]: {
          backgroundPosition: 'left center',
          backgroundImage: `url(${minimisedlogo})`,
          height: minimisedlogo ? 38 : 43
        },
      }
    },
    headerLogoLinkLoggedIn: {
      display: "none",
      '@media(max-width: 768px)': {
        display: 'block',
      },
    },
    headerButton: {
      width: 190,
      marginRight: 20
    },
    headerPortalLanguageDropdown: {
      marginLeft: 30,
      marginRight: 10,
      '& .languageSelectDropdown': {
        outline: 'none',
        '& .Mui-expanded': {
          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderBottom: 'none',
            borderWidth: '1px',
            borderRadius: '4px 4px 0px 0px'
          }
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px'
        },
        '& .customizeInputIcon': {
          width: 16,
          height: 16,
          top: 11,
          left: 15
        },
        '& .MuiOutlinedInput-root': {
          padding: '8px 39px 8px 8px'
        },
        '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
          padding: 0,
          color: '#4A4A4A',
          fontSize: 14,
          fontWeight: 450,
          lineHeight: 22,
          height: 24,
          minWidth: 25,
        },
        '& .MuiAutocomplete-endAdornment .MuiButtonBase-root': {
          padding: 4
        }
      }
    },
    '& .MuiPopper-root': {
      padding: 4
    },
    loggedInDesktopBtns: {
      '@media(max-width: 768px)': {
        display: 'none'
      },
    },
    registrationLinkButton: {
      width: 190,
      color: "#2D91E9",
      border: "1px solid #E8E8E8",
      background: "#FFF",
      "&:hover": {
        background: "#FFF",
        border: "1px solid #2D91E9",
      },
    },
    headerContainer: {
      backgroundColor: background,
      display: 'flex',
      padding: 20,
      minHeight: 45,
      '@media(max-width: 768px)': {
        position: 'relative',
        padding: 15,
        minHeight: 42,
      },
    },
    headerContainerLoggedIn: {
      '@media(max-width: 1200px)': {
        paddingLeft: 110,
      },
    },
    headerLeft: {
      flex: 1,
      maxWidth: 150,
      [theme.breakpoints.down('sm')]: {
        maxWidth: 38,
        position: 'absolute',
        left: 0,
        right: 0,
        margin: 'auto',
      },
    },
    headerLeftAuthenticated: {
      backgroundImage: 'none',
      maxWidth: 'none',
      width: '50%',
      flex: 'auto',
      // Todo: fix logged in header
      '@media(max-width: 768px)': {
        display: 'block',
        position: 'absolute',
        maxWidth: 130,
        left: 0,
        right: 0,
        margin: 'auto'
      },
      [theme.breakpoints.down('sm')]: {
        width: 35,
      },
    },
    referralsSearchOpen: {
      width: '100%',
      '@media(max-width: 768px)': {
        maxWidth: 'fit-content'
      },
      '@media(max-width: 480px)': {
        maxWidth: '50%'
      },
      [theme.breakpoints.down('sm')]: {
        width: 'max-content',
      }
    },
    logoWithReferralsSearch: {
      '@media(max-width: 768px)': {
        display: 'none'
      }
    },
    headerRight: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      justifyContent: 'flex-end'
    },
    loggedOutMobileBtn: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        background: 'transparent',
        border: 'none',
        padding: '0 10px',
        outline: 'none'
      },
      '& > svg': {
        width: 25,
        height: 25,
        verticalAlign: 'middle'
      }
    },
    loggedOutRight: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
        '&.mobileNavOpen': {
          display: 'block',
          position: 'absolute',
          right: 16,
          top: 88,
          background: 'white',
          padding: 20,
          textAlign: 'center',
          borderRadius: 5,
          boxShadow: '0 2px 6px rgba(0,0, 0,0.2)',
          zIndex: 99,
          '&::after': {
            content: '',
            width: 0,
            height: 0,
            border: '0 solid transparent',
            borderLeftWidth: 100,
            borderRightWidth: 100,
            borderTop: '100px solid black',
            position: 'absolute',
            right: 16,
            top: 88,
          },
          '& > p': {
            fontSize: '165%',
            fontWeight: 400,
            letterSpacing: '-0.5px'
          },
          '& > button': {
            display: 'block',
            marginRight: 0,
            marginLeft: 0,
            width: 220,
            marginTop: 10
          },
          '& > div': {
            margin: 0,
            marginTop: 10
          }
        }
      },
      '& > button': {
        marginRight: 0,
        marginLeft: 30,
      }
    },
  };
})());
